import { ApiLojaInstance, ApiLojaPost } from "data/ApiLoja";
import { getUserToken } from "utils/getToken";
import { getCertificateActionRequest } from "./certificateAdminRoute";

export const requestCertificateAction = async (
  registrationId: number,
  action: string,
  reason?: string,
  participantName?: string
) => {
  const request = getCertificateActionRequest(registrationId, action);
  const body = { action, reason, participantName };

  if (request.method === "POST") {
    return ApiLojaPost(request.url, body);
  }

  return ApiLojaInstance.patch(request.url, body, {
    headers: { Authorization: getUserToken() },
  });
};
